export default "__VITE_ASSET__cd8c8763__"